// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2hj4w","search":"Settings_search__2sIQZ","filter":"Settings_filter__2RLBs"};